import axios from 'axios';

// Base API URL
const BASE_URL = '';

// Function to make requests with optional individual headers
export const fetchData = async (tokens = []) => {
  try {
    // Define API requests with individual headers
    const requests = [
      axios.get(
        `https://east-1.calltools.io/api/agentstatuses/?queue=3768&agent_status_id=12893`,
        {
          headers: tokens[0] ? { Authorization: `Token ${tokens[0]}` } : {},
        }
      ),
      axios.get(
        `https://abg.tldcrm.com/api/public/dialer/ready/%7B5555555555%7D?erq=256-dGgzTVhGUzQvangxVEVTT28rNFlVUmhyTGlZbGltVmk1QWpTSWdtOU5QQit2Z3Z5MWdUbDgvVXJyeDc4VnpNeA`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
      axios.get(
        `https://chi.tldcrm.com/api/public/dialer/ready/18883685779?pol=365&ava=1&cnt=true&ing=25852`,
        {
          headers: tokens[2] ? { Authorization: `Token ${tokens[2]}` } : {},
        }
      ),
      axios.get(
        `https://chi.tldcrm.com/api/public/dialer/ready/18886781319?pol=365&ava=1&cnt=true&ing=25853`,
        {
          headers: tokens[3] ? { Authorization: `Token ${tokens[3]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5725&agent_status_id=28735`,
        {
          headers: tokens[4] ? { Authorization: `Token ${tokens[4]}` } : {},
        }
      ),
      axios.get(
        `https://east-1.calltools.io/api/agentstatuses/?queue=3832&agent_status_id=12893`,
        {
          headers: tokens[5] ? { Authorization: `Token ${tokens[5]}` } : {},
        }
      ),
      axios.get(
        `https://east-1.calltools.io/api/agentstatuses/?queue=3834&agent_status_id=12893`,
        {
          headers: tokens[6] ? { Authorization: `Token ${tokens[6]}` } : {},
        }
      ),
      axios.get(
        `https://east-1.calltools.io/api/agentstatuses/?queue=3833&agent_status_id=12893`,
        {
          headers: tokens[7] ? { Authorization: `Token ${tokens[7]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5866&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5878&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5880&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5881&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5882&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5883&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5884&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5889&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5885&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5886&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5887&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5888&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5890&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5892&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5893&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5894&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5895&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5896&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5897&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5898&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5899&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5900&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://east-2.calltools.io/api/agentstatuses/?queue=5901&agent_status_id=20561&ready=true `,
        {
          headers: tokens[8] ? { Authorization: `Token ${tokens[8]}` } : {},
        }
      ),
      axios.get(
        `https://automate.nextgenict.com/webhook/482b116b-d5d4-4987-8990-89857388840f?tag=pd9315&leads=yellow`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
      axios.get(
        `https://automate.nextgenict.com/webhook/482b116b-d5d4-4987-8990-89857388840f?tag=pd9315&leads=yellow`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
      axios.get(
        `https://kig.tldcrm.com/api/public/dialer/ready/5126653983?ava=1&ugr=AGENT&usr=1092,1093,23851,23393,39545`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
      axios.get(
        ` https://wase.tldcrm.com/api/public/dialer/ready?ava=1&ing=26591`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
      axios.get(
        `https://wase.tldcrm.com/api/public/dialer/ready?ava=1&ing=26592`,
        {
          headers: tokens[1] ? { Authorization: `Token ${tokens[1]}` } : {},
        }
      ),
    ];

    // Fetch all requests
    const responses = await Promise.all(
      requests.map((req, index) =>
        req
          .then((res) => res.data)
          .catch((err) => {
            console.error(
              `Error in request ${index + 1}:`,
              err?.response?.status,
              err?.message
            );
            return {
              error: `Request ${index + 1} failed`,
              status: err?.response?.status,
            };
          })
      )
    );

    console.log('Final API Responses:', responses);
    return responses;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
